export default __webpack_public_path__ + "static/media/cijevizolirana3.d4013e2a.jpeg";